import IconLibrary from './IconLibrary';

export default IconLibrary;
